import { ONBOARDING_FLOW_FLAG_KEY } from '@/features/flags';
import { useManualExposure } from '@/hooks/amplitude/use-manual-exposure';

interface UseGuidedTourExposureOptions {
  /** Resolved guided-tour arm (`experimental-3` AND a preview-capable viewport). */
  isGuidedTour: boolean;
  /**
   * The user actually reached the shared mic-test entry point on a flow wide
   * enough to render the preview pane. Both arms diverge from here, so both
   * fire exposure — and users below `lg`, who are excluded from the
   * experiment, fire neither.
   */
  isAtTourEntryPoint: boolean;
}

/**
 * Amplitude exposure for the onboarding guided-tour experiment. PostHog
 * resolves the flag, but the analysis lives in Amplitude, so `$exposure` has to
 * be fired manually at the point the arms visibly diverge rather than at flag
 * evaluation.
 *
 * The tour is the `experimental-3` arm of `release-new-onboarding-flow`, so the
 * exposure reports that flag with the arm the user actually sees: the tour, or
 * the sample-conversation flow (`experimental-2`) it expands on.
 */
export function useGuidedTourExposure({
  isGuidedTour,
  isAtTourEntryPoint,
}: UseGuidedTourExposureOptions) {
  useManualExposure({
    flagKey: ONBOARDING_FLOW_FLAG_KEY,
    isEnabled: isGuidedTour,
    variant: isGuidedTour ? 'experimental-3' : 'experimental-2',
    isVisible: isAtTourEntryPoint,
  });
}
